import React from 'react';
import './accordion.scss';
import { Sprite, Button } from '@agissc/ktag-map';
import useAppState from '../../../AppStore';
import { AccordionName } from '../../../UIStateSlice';

interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  id: string;
  onToggle?: (state: boolean) => void;
}

const AccordionItem = ({ title, children, id, onToggle }: AccordionItemProps) => {
  const accordions = useAppState((state) => state.accordions);
  const setAccordionItem = useAppState((state) => state.setAccordionItem);

  const isExpanded = !!accordions[AccordionName.IDENTIFY_CONFIGURATION]?.find((i) => {
    return i.id === id && i.expanded;
  });

  const onClick = () => {
    setAccordionItem(AccordionName.IDENTIFY_CONFIGURATION, id, !isExpanded);
    if (onToggle) {
      onToggle(isExpanded);
    }
  };

  return (
    <div
      className={`ok_accordion_item ${isExpanded ? '' : 'ok_accordion_collapsed'}`}
      key={id}
    >
      <div className="ok_accordion_header">
        <div className="ok_accordion_title">{title}</div>
        <Button additionalClassNames="ok_accordion_collapse_button" onClick={onClick}>
          <figure className="ok_accordion_collapse_figure">
            <Sprite
              id={isExpanded ? 'chevron-up' : 'chevron-down'}
              additionalClassNames="ok_accordion_chevron"
            />
          </figure>
        </Button>
      </div>
      {isExpanded && <div className="accordion-content">{children}</div>}
    </div>
  );
};

export default AccordionItem;
